import axios from "axios";

export default function getLoyaltyPoint(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/campaignV2/customer/loyaltyPoint/detail`, {
        uuid,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
